import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('zaptic-icon-lightning')
export class IconLightning extends LitElement {
    static styles = css`
        :host {
            display: block;
        }

        svg:hover {
            cursor: pointer;
        }
    `

    render() {
        return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="25" display="block" viewBox="0 0 32 25">
            <path
                fill="var(--yellow, #ffc740)"
                d="M13.7 16.4h5.6v7.4c0 .2.2.3.4.4.2 0 .4.1.6 0 .2 0 .4-.2.5-.3l8-13c0-.1.2-.3.2-.5v-.5c0-.2-.2-.3-.3-.4-.1 0-.3-.1-.5-.1h-5.6V2c0-.2-.2-.3-.4-.4-.2 0-.4-.1-.6 0-.2 0-.4.2-.5.3l-8 13c0 .1-.2.3-.2.5v.5c0 .2.2.3.3.4s.3.1.5.1Zm6.9-10.7v4.9c0 .1 0 .3.2.4 0 .1.2.2.3.3h5.3l-5.2 8.4v-4.5c0-.1 0-.3-.2-.4 0-.1-.2-.2-.3-.3h-5.3l5.2-8.8Zm-5.9.8c0 .5-.4.9-.9.9H9.9v3.9c0 .5-.4.9-.9.9s-.9-.4-.9-.9V7.4H4.2c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.9v-4c0-.5.4-.9.9-.9s.9.4.9.9v3.9h3.9c.5 0 .9.4.9.9Z"
            />
        </svg> `
    }
}
